import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CardItem(props) {
  const images = Array.isArray(props.src) ? props.src : [props.src];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <li className='cards__item'>
        <Link className='cards__item__link' to={props.path} onClick={() => window.scrollTo(0, 0)}>
          <figure className='cards__item__pic-wrap' data-category={props.label}>
            {images.length > 1 ? (
              images.map((src, i) => (
                <img
                  key={i}
                  className={`cards__item__img ${i === currentIndex ? 'slide-active' : 'slide-hidden'}`}
                  alt={props.label}
                  src={src}
                />
              ))
            ) : (
              <img
                className='cards__item__img'
                alt={props.label}
                src={images[0]}
              />
            )}
          </figure>
          <div className='cards__item__info'>
            {props.icon && <span className='cards__item__icon'>{props.icon}</span>}
            <h5 className='cards__item__text'>{props.text}</h5>
          </div>
        </Link>
      </li>
    </>
  );
}

export default CardItem;
